function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadinglistCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.27,
    y: 110.99,
    width: 166.63,
    height: 7.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.62,
    y: 118.3,
    width: 7.31,
    height: 24.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.62,
    y: 118.3,
    width: 7.31,
    height: 7.47,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.26,
    y: 118.3,
    width: 7.31,
    height: 24.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.26,
    y: 118.3,
    width: 7.31,
    height: 7.47,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.96,
    y: 81.84,
    width: 46.57,
    height: 11.73,
    transform: "translate(411.95 -236.54) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.68,
    y: 58.63,
    width: 5.12,
    height: 11.73,
    transform: "translate(388.73 -259.75) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.29,
    y: 68.69,
    width: 1.9,
    height: 11.73,
    transform: "translate(398.8 -249.69) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.41,
    y: 95.73,
    width: 5.12,
    height: 13.19,
    transform: "translate(427.3 -222.65) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.04,
    y: 79.73,
    width: 54.33,
    height: 8.2,
    transform: "translate(418.03 -250.38) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.72,
    y: 69.76,
    width: 20.89,
    height: 4.92,
    transform: "translate(406.39 -261.95) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.25,
    y: 84.89,
    width: 54.33,
    height: 8.2,
    transform: "translate(170.68 -237.5) rotate(44.67)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.81,
    y: 89.3,
    width: 20.89,
    height: 4.92,
    transform: "translate(173.45 -238.7) rotate(44.67)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.62,
    y: 83.41,
    width: 41.26,
    height: 13.92,
    transform: "translate(435.62 -254.89) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.33,
    y: 97.74,
    width: 3.85,
    height: 13.92,
    transform: "translate(449.96 -240.55) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.51,
    y: 92.55,
    width: 1.49,
    height: 13.92,
    transform: "translate(444.77 -245.75) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.18,
    y: 86.8,
    width: 38.78,
    height: 9.61,
    transform: "translate(405.18 -221.96) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.76,
    y: 100.27,
    width: 3.61,
    height: 9.61,
    transform: "translate(418.65 -208.49) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.76,
    y: 77.21,
    width: 3.61,
    height: 9.61,
    transform: "translate(395.59 -231.55) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.87,
    y: 82.2,
    width: 1.4,
    height: 9.61,
    transform: "translate(400.58 -226.57) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21,61.31c-8.2,8-9.58,20.46-7.85,31.34.05.25.43.18.43-.05,0-2.48-.08-4.93-.07-7.38,0-.11.08-.22.13-.33a16.53,16.53,0,0,0,5.33-5.73c1.37-2.69,1.91-5.73,2.95-8.54.1-.27-.19-.19-.37-.06-5,3.68-6.58,7.64-8,12.94a44.26,44.26,0,0,1,.87-8.24,28.08,28.08,0,0,1,6.82-13.73C420.56,61.39,420.35,61.17,420.21,61.31Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.75,62.25c1.42,0,2.3,2.3,3.4,3a1.06,1.06,0,0,0,1.56-.24c1.09-1.53-.41-3.4-1.81-4.45a15.39,15.39,0,0,0,2.92,1.34,1,1,0,0,0,1.32-.79c.48-2.07-2.12-3-3.91-3,.87-.6,3.35-2.23,2-3s-4.25,1.53-5.19,2.31c-1.4,1.13-3.06,2.82-3.13,4.59C418.86,64,420.67,62.68,421.75,62.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.35,62.6c1.8-.82,5.27.36,5.56-.32.6-1.39-2.17-2.35-3.67-2.53,1.38-.38,4-1,3.94-2.3-.1-1.62-4.05-.23-6.05,1.31-2.51,1.93-2.5,3.79-2.08,4.16S421.05,62.73,421.35,62.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.53,60.52c8.5,7.71,10.35,20.07,9,31,0,.25-.42.2-.43,0-.09-2.48-.11-4.93-.21-7.38l-.14-.32a16.52,16.52,0,0,1-5.54-5.52c-1.48-2.64-2.13-5.66-3.28-8.43-.11-.27.18-.2.37-.07,5.13,3.49,6.87,7.39,8.5,12.62a44.3,44.3,0,0,0-1.18-8.2,28.09,28.09,0,0,0-7.34-13.46A.15.15,0,0,1,401.53,60.52Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,61.51c-1.41.1-2.21,2.39-3.28,3.09a1.07,1.07,0,0,1-1.57-.18c-1.15-1.48.28-3.41,1.64-4.52A15.82,15.82,0,0,1,394,61.36a1,1,0,0,1-1.35-.74c-.55-2.06,2-3.08,3.79-3.19-.89-.57-3.43-2.1-2.14-3s4.3,1.37,5.28,2.1c1.44,1.08,3.16,2.71,3.29,4.47C403,63.11,401.13,61.9,400,61.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.45,61.84c-1.84-.75-5.25.57-5.57-.11-.65-1.36,2.08-2.42,3.56-2.66-1.39-.32-4.05-.82-4-2.15,0-1.62,4-.38,6.08,1.08,2.59,1.83,2.65,3.69,2.25,4.08S400.75,62,400.45,61.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,80.89a81.71,81.71,0,0,0,2.64,12.19.3.3,0,0,0,.59-.12c-.56-3.76-1.58-7.44-2.13-11.2a56.06,56.06,0,0,1-.66-11.5c.36-6.34,2.08-13.07,6.21-18,.09-.12-.1-.28-.19-.17-8.28,9.64-7,21.47-6.95,22.53-1.17-4-2.38-8.57-6.81-12.64-.19-.17-.34-.09-.31.21.79,7.41,2.85,11.27,7.15,15.23C409.89,78.57,410,79.73,410.23,80.89Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,53.34c1.49-.66,3.54,1.23,5,1.36a1.21,1.21,0,0,0,1.49-1c.37-2.13-2.13-3.33-4.11-3.71,1.25-.07,2.48.26,3.71-.07a1.19,1.19,0,0,0,1-1.49c-.55-2.39-3.71-2-5.59-1.18.6-1.06,2.35-4,.58-4.18s-3.64,3.73-4.23,5c-.88,1.88-1.76,4.47-.93,6.34C414.81,56.57,416.05,54.34,417,53.34Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.71,53.91c1.46-1.76,5.65-2.28,5.61-3.14-.08-1.74-3.43-1.34-5.08-.78,1.24-1.08,3.68-3,2.93-4.36-.92-1.63-4.31,1.8-5.62,4.4-1.64,3.27-.68,5.19-.06,5.37C415.34,55.64,416.47,54.2,416.71,53.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.78,83.12,401.13,111h22.21c-.46-2.47-4.59-27.91-4.59-27.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.86,53.71H220.74v215.5H55.86Zm160.53,4.35H60.21v206.8H216.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.82,
    y: 59.19,
    width: 4.35,
    height: 207.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 62.5,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 131.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 69.31,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 144.67) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 76.12,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 158.3) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 82.93,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 171.92) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 89.74,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 185.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 96.55,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 199.16) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 103.37,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 212.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 110.18,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 226.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.92,
    y: 116.99,
    width: 172.77,
    height: 6.05,
    transform: "translate(276.6 240.03) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.83,
    y: 61.27,
    width: 1.09,
    height: 139.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.44 205.88 67.3 205.88 66.33 200.34 64.41 200.34 63.44 205.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.91,
    y: 61.27,
    width: 1.09,
    height: 201.88,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.53 267.23 63.38 267.23 62.42 261.68 60.49 261.68 59.53 267.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.17,
    y: 52.86,
    width: 186.26,
    height: 12.67,
    transform: "translate(276.6 118.38) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.95,
    y: 279.18,
    width: 104.03,
    height: 143.97,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.91,
    y: 273.84,
    width: 114.11,
    height: 5.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.02,
    y: 273.84,
    width: 35.89,
    height: 5.34,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.98,
    y: 279.18,
    width: 35.25,
    height: 143.97,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.77,345.81H316.15V299.68h81.62Zm-81.37-.25h81.12V299.93H316.4Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.57,
    y: 313.16,
    width: 15.89,
    height: 9.13,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,321.73H350.14v-8h16.14Zm-15.89-.25H366V314H350.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.77,403.77H316.15V357.64h81.62Zm-81.37-.25h81.12V357.89H316.4Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.57,
    y: 371.12,
    width: 15.89,
    height: 9.13,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,379.69H350.14v-8h16.14Zm-15.89-.25H366v-7.51H350.39Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-65"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 463.75,
    rx: 172.87,
    ry: 9.48,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29.82 422.79 84.86 422.55 139.91 422.46 250 422.3 360.09 422.46 415.13 422.55 470.18 422.79 415.13 423.04 360.09 423.13 250 423.29 139.91 423.13 84.86 423.04 29.82 422.79",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.21,348.6s20.22-4.58,31.3-14.79,17.27-28.5,17.27-28.5a173.42,173.42,0,0,0-22.67,6c-1.81,1.93-5.26,5.92-6.86,9.69a47.14,47.14,0,0,1-.06-6.93A30.79,30.79,0,0,0,418,318.4C408.81,326.44,406.21,348.6,406.21,348.6Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.16,314.2c2.75-1.91,5.56-3.75,8.3-5.67a.16.16,0,0,0-.17-.27c-5.2,3.11-10.34,6.44-15.31,9.92-1.73,1.21-3.43,2.48-5.11,3.77.11-.2.23-.4.35-.6.61-1,1.25-2,1.88-3a42.84,42.84,0,0,1,4.3-5.73c.06-.06,0-.16-.1-.09-1.58,1.81-3.15,3.61-4.59,5.53-.68.92-1.31,1.87-1.92,2.84-.31.5-.61,1-.9,1.52l-.31.53c-2.61,2.05-5.16,4.19-7.59,6.45-1.5,1.4-2.94,2.85-4.34,4.34.78-2.45,1.47-4.92,2.37-7.33,0-.08-.1-.12-.13,0-.88,2.52-1.84,5.06-2.53,7.66-1.54,1.67-3,3.41-4.42,5.21,0-.11.05-.22.07-.33.23-1,.47-1.9.73-2.85.49-1.83,1-3.64,1.64-5.44a31.79,31.79,0,0,1,5.43-10.25c.06-.07,0-.17-.1-.1-3.95,4.68-6.26,10.28-7.74,16.17-.22.86-.42,1.72-.62,2.59-.1.46-.22.93-.3,1.4-.61.82-1.21,1.66-1.78,2.51a87.53,87.53,0,0,0-8.56,16.78,192.8,192.8,0,0,0-6.48,20.19.11.11,0,0,0,.21,0c3.95-11.82,8-23.82,14.76-34.4,1.43-2.23,3-4.38,4.62-6.46a37.93,37.93,0,0,0,9.83-2,43.47,43.47,0,0,0,9.85-4.76,60.25,60.25,0,0,0,5.05-3.82c.08-.06,0-.17-.09-.1a40.25,40.25,0,0,1-9.26,5.6A51,51,0,0,1,419,337.5c-1.49.32-3,.56-4.52.77a84.84,84.84,0,0,1,6-6.61c.68-.68,1.39-1.33,2.09-2a48.44,48.44,0,0,1,7.47-4.28c3.31-1.6,6.58-3.3,9.85-5,1.85-.94,3.69-1.91,5.56-2.82.08,0,0-.15-.08-.11-3.32,1.6-6.69,3.1-10.05,4.64-3.15,1.44-6.35,2.89-9.38,4.6l-.38.22c2.74-2.38,5.57-4.65,8.47-6.84C436.68,318.09,439.39,316.11,442.16,314.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,324.62c-1.65.72-3.32,1.36-4.95,2.12s-3.26,1.7-4.85,2.64c-.07,0,0,.14.07.11,1.61-.77,3.24-1.5,4.84-2.3s3.25-1.7,4.93-2.44C441.13,324.72,441.09,324.59,441,324.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,246.73a28.89,28.89,0,0,1,6,16.79c.06,1.81-.22,4.33-.43,7.31,7.53,4,13.19,11.27,13.19,11.27-4.28-2.57-10.16-3.61-13.33-3.19a39.47,39.47,0,0,0,.77,6c1.4-.08,4.1.11,8.57,1.7a19.09,19.09,0,0,0-7.73,1.53c3.6,11.47,14.32,23.24,43.89,28.25a62.05,62.05,0,0,0-5.24-41.63C377.42,257.37,340.54,246.73,340.54,246.73Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.76,365.48c-.51-4.9-1.16-9.78-1.91-14.65a294.26,294.26,0,0,0-6-28.95,114.64,114.64,0,0,0-4.27-13.19,20.89,20.89,0,0,0,.11-2.37c0-.95,0-1.9,0-2.84,0-1.9-.11-3.79-.28-5.68a67.14,67.14,0,0,0-1.81-11.09c-.54-2.1-1.17-4.18-1.79-6.26a.07.07,0,1,0-.13,0,81.14,81.14,0,0,1,2.18,11.07,102.83,102.83,0,0,1,1,11.1c0,1,.06,2,.06,3,0,.43,0,.86,0,1.3a94.93,94.93,0,0,0-5-10.31,124.84,124.84,0,0,0-10.12-15.15,6.51,6.51,0,0,0-.24-1.65c-.14-.66-.29-1.32-.43-2-.31-1.35-.65-2.7-1-4-.74-2.68-1.71-5.27-2.55-7.92,0-.08-.15-.05-.13,0,.78,2.62,1.3,5.33,1.9,8,.3,1.32.59,2.64.88,4l.42,2,0,.15q-1.8-2.27-3.67-4.46c-5.64-6.62-11.84-12.73-18.07-18.8-.77-.75-1.55-1.47-2.33-2.21-.06-.06-.15,0-.09.1,6,6.22,11.82,12.5,17.37,19.08,1.32,1.56,2.62,3.15,3.9,4.75-.67-.46-1.35-.9-2-1.34-1.72-1.12-3.46-2.22-5.26-3.23s-3.6-2-5.44-2.9-3.93-1.7-5.76-2.77c-.08,0-.15.09-.07.12a44.38,44.38,0,0,1,5.4,3c1.8,1.07,3.6,2.15,5.37,3.27s3.48,2.19,5.21,3.31c1.44.93,2.86,1.95,4.35,2.82a139.66,139.66,0,0,1,9.47,13.79,101.68,101.68,0,0,1,4.9,9.29l-1.06-.46-2.71-1.2c-1.74-.78-3.49-1.53-5.23-2.29-3.32-1.44-6.69-2.77-9.94-4.35a45.12,45.12,0,0,1-5.31-2.95c-.07-.05-.14.07-.07.12,6.07,4.18,12.87,7.13,19.58,10.1l2.91,1.29c.8.35,1.6.75,2.42,1.06a103.76,103.76,0,0,1,5,13.7A279.71,279.71,0,0,1,398,347.55c1.7,9.66,2.84,19.38,3.73,29.15.11,1.22.22,2.43.36,3.65a.39.39,0,0,0,.77,0C402.79,375.38,402.28,370.41,401.76,365.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.77,283.8c-.55-3-1.35-5.95-2.16-8.89,0-.09-.15-.05-.13,0,.75,2.89,1.29,5.83,1.83,8.77s1,6,1.46,9c0,0,.09,0,.08,0A78.4,78.4,0,0,0,383.77,283.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,292a54.06,54.06,0,0,0-6.43-3.62c-1.08-.55-2.17-1.08-3.26-1.61s-2.3-1-3.42-1.56a.07.07,0,1,0-.06.12c1.08.54,2.1,1.2,3.17,1.78s2.18,1.2,3.28,1.79c2.16,1.16,4.29,2.45,6.56,3.39A.17.17,0,0,0,371,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.58,313.58s18.71-4.46,27.3-17c8.2-12,10.85-32.42,11.06-34.21-.34,1.65-4.2,19.5-16.93,27.82C418.26,296.55,408.84,301.79,406.58,313.58Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.85,281.26a23.88,23.88,0,0,0-6.9,11.36s.05.06.06,0a27.81,27.81,0,0,1,6.93-11.27C424,281.31,423.91,281.2,423.85,281.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.58,313.58s18.71-4.46,27.3-17c8.2-12,10.85-32.42,11.06-34.21a.69.69,0,0,0,0-.13s-9,12.75-18.4,16S403.88,292.74,406.58,313.58Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,269.27a76.88,76.88,0,0,1-5.79,9.88,39.54,39.54,0,0,1-7.69,7.92c-2.54,2-5.23,3.85-7.8,5.83l.06-.1c.48-.71,1-1.41,1.53-2.09,1.07-1.37,2.24-2.66,3.42-3.94,2.32-2.52,4.7-5,6.78-7.72a28.63,28.63,0,0,0,3-4.83c0-.08-.09-.13-.13-.05-3,6.32-9.09,10.37-13.42,15.71a28.56,28.56,0,0,0-1.73,2.36,9.79,9.79,0,0,0-1.07,1.9,39.38,39.38,0,0,0-6.39,6.45,27.82,27.82,0,0,1,.75-3.63,18.41,18.41,0,0,1,2-4.73c0-.08-.07-.16-.12-.08a22.63,22.63,0,0,0-2.18,4.71,16.43,16.43,0,0,0-.68,4h0a37.56,37.56,0,0,0-2.53,3.93l.24-1.2c.37-1.86.78-3.72,1.26-5.56a33.39,33.39,0,0,1,4.5-10.54c.05-.07-.06-.15-.11-.08a40.11,40.11,0,0,0-5,10.31c-.6,1.84-1.07,3.71-1.49,5.59-.21.92-.39,1.84-.57,2.77-.09.48-.19,1-.27,1.46a67.49,67.49,0,0,0-4.32,12.68,189.23,189.23,0,0,0-4,23.65A198.94,198.94,0,0,0,398.61,369c0,1,.08,2.1.14,3.15,0,.27.42.31.43,0,.19-4.15.3-8.31.54-12.46s.61-8.29,1-12.42a221.9,221.9,0,0,1,3.9-24.19c1.52-6.84,3.48-13.72,7.22-19.71a37.39,37.39,0,0,1,6.75-8c2.62-2.35,5.49-4.42,8.26-6.6a45,45,0,0,0,7.57-7.28,59.75,59.75,0,0,0,5.95-9.65c.44-.85.89-1.69,1.34-2.54C441.8,269.26,441.69,269.19,441.65,269.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.42,272a64.11,64.11,0,0,1-4.17,7.29c0,.05.05.11.09.05a50.84,50.84,0,0,0,4.21-7.3C438.59,272,438.45,271.93,438.42,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.94,305.31s-.3,26.58,15.59,34.26,24.42,1.28,35.22,3.85h0c-.42-.64-8.13-11.72-20.39-14.77C355.73,325.5,341.76,316.39,337.94,305.31Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.94,305.31s-.3,26.58,15.59,34.26,24.42,1.28,35.22,3.85h0a59.8,59.8,0,0,0-18.07-5.33C360.64,336.87,341.49,330.34,337.94,305.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8,343.89a27.38,27.38,0,0,0-6.32-4.28c-.34-.16-.7-.29-1-.44-.17-.21-.35-.41-.54-.61a20,20,0,0,0-1.49-1.42,22,22,0,0,0-3.2-2.31c-2.63-1.55-5.52-2.63-8.21-4.07-.08,0-.15.08-.07.12,1.33.69,2.62,1.46,3.92,2.21s2.54,1.44,3.77,2.23a27.8,27.8,0,0,1,3.15,2.36c.28.24.54.51.81.78a42.89,42.89,0,0,0-5.37-1.43c-2.91-.59-5.85-1-8.76-1.62a43.58,43.58,0,0,1-4.21-1.14c-1.32-1.06-2.64-2.12-3.89-3.27a31.78,31.78,0,0,1-4.11-4.56c-.05-.07-.17,0-.11.08a48.73,48.73,0,0,0,6.51,7.19c-.68-.26-1.36-.54-2-.84a32.86,32.86,0,0,1-13.54-11.27c-.05-.08-.17,0-.12.07a37.14,37.14,0,0,0,11,10.52,32.69,32.69,0,0,0,6.92,3.27,63.24,63.24,0,0,0,8.6,2,60.77,60.77,0,0,1,8.43,2,25.27,25.27,0,0,1,7.06,3.72A33.08,33.08,0,0,1,396.45,355c3,6,4.44,12.78,5.24,19.44,0,.28.47.28.45,0C401.4,363.28,398.41,351.65,389.8,343.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.35,335.23a9.16,9.16,0,0,0-3.27-3,11.92,11.92,0,0,1-3.88-3.21c-.05-.07-.17,0-.12.07a13,13,0,0,0,3.43,3.07,11.94,11.94,0,0,1,3.74,3.1C371.3,335.35,371.39,335.29,371.35,335.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.79 363.51 380.51 378.13 382.73 422.79 416.07 422.79 418.29 378.13 419.01 363.51 379.79 363.51",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.79 363.51 380.51 378.13 418.29 378.13 419.01 363.51 379.79 363.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.45,
    y: 357.41,
    width: 43.9,
    height: 13.95,
    transform: "translate(798.79 728.77) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.19,456.64c-2.33.75-68.82-.1-71.33-1.74-1-.6-1.4-10.3-1.6-22v-.37q-.07-3.63-.08-7.43c0-.35,0-.69,0-1l3.22-34.49,44.48.43-4.38,34.17,0,1.36-.27,7.07,0,.73S230.44,445,233,447.1,237.53,455.89,235.19,456.64Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.19,456.64c-2.33.75-68.82-.1-71.33-1.74-1-.6-1.4-10.3-1.6-22v-.37q-.07-3.63-.08-7.43c0-.35,0-.69,0-1l43.32.11,0,1.36-.27,7.07,0,.73S230.44,445,233,447.1,237.53,455.89,235.19,456.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2,456.63c-1.2.39-19.26.35-36.92,0-3.55-.07-7.08-.15-10.45-.24-12.59-.34-23-.86-24-1.49s-1.4-10-1.59-21.54c0-.17,0-.33,0-.49s0-.26,0-.38h.05l42.85.07,0,.74S230.45,445,233,447.09,237.53,455.89,235.2,456.63Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.47,454.05c-11.2-.42-56.43-1.05-67.54-.61-.09,0-.09.07,0,.07,11.1.66,56.33.92,67.54.72C234.71,454.23,234.71,454.06,234.47,454.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.93,432.75c-4.4-.88-9.8-.27-13.21,2.83-.13.12,0,.31.18.26a62.51,62.51,0,0,1,13-2.53A.28.28,0,0,0,209.93,432.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,434.71c-4.4-.88-9.8-.27-13.21,2.83-.13.12,0,.31.18.26a62.51,62.51,0,0,1,13-2.53A.28.28,0,0,0,213.09,434.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.25,436.67c-4.4-.88-9.8-.27-13.21,2.83-.13.12,0,.31.18.26a62.51,62.51,0,0,1,13-2.53A.28.28,0,0,0,216.25,436.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,456.63c-3.55-.07-7.08-.15-10.45-.24-12.59-.34-23-.86-24-1.49s-1.4-10-1.59-21.54c0-.17,0-.33,0-.49s0-.26,0-.38h.05C168.18,436.61,188.87,450.38,198.28,456.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.72,432.72H159.83s9.62-111.85,9.25-113.8c-.48-2.5-3.31-13.82-7.08-28.61-1.18-4.63-2.45-9.59-3.78-14.74-3.57-13.91-7.51-29.12-10.94-42.35-5.15-19.82-9.17-35.22-9.17-35.22h40.58s4.73,15,10.7,34.5c9.72,31.7,22.71,75.33,24,85.94C215.46,335.57,207.72,432.72,207.72,432.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6,424.55c-7.32-.15-5.21-.21-12.53-.28-3.58,0-27.1-.24-30.44.32a.08.08,0,0,0,0,.15c3.34.55,26.86.34,30.44.31,7.32-.08,5.22-.14,12.53-.29A.11.11,0,0,0,205.6,424.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.08,312.09c-1.57-6.92-3.92-13.7-6-20.5q-6.23-20.7-12.53-41.39-3.15-10.35-6.33-20.68-1.6-5.22-3.23-10.43c-1.06-3.4-2.28-6.77-3.24-10.2-.39-1.39-.6-.62-.1,1.15,1,3.57,2,7.14,3.05,10.71q3.09,10.58,6.23,21.15,6.22,21,12.57,42,3.17,10.55,6.34,21.07a85.6,85.6,0,0,1,2.59,10.2,46.8,46.8,0,0,1,.43,10.9c-.46,7.33-1.3,14.65-2,21.95s-1.35,14.65-2,22q-2,21.87-4,43.73-.25,2.78-.47,5.55c0,.62.89.57,1,0,1.58-14.42,2.78-28.88,4.13-43.32s2.69-28.73,4-43.09c.34-3.61.72-7.22.72-10.85A44.59,44.59,0,0,0,178.08,312.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,198c-2.81,21.8-8.17,62.67-12.08,92.32C152.84,254.4,138.11,198,138.11,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,457.29c-2.33.76-68.82.16-71.34-1.48-1-.6-1.44-10.29-1.68-22v-.37c-.06-2.42-.1-4.91-.11-7.43,0-.35,0-.69,0-1-.16-16.93,1.06-34.49,1.06-34.49l43.46.27-1.2,34.17-.05,1.36-.24,7.07,0,.73s25.34,11.61,27.92,13.7S185.93,456.54,183.6,457.29Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,457.29c-2.33.76-68.82.16-71.34-1.48-1-.6-1.44-10.29-1.68-22v-.37c-.06-2.42-.1-4.91-.11-7.43,0-.35,0-.69,0-1l43.32-.05-.05,1.36-.24,7.07,0,.73s25.34,11.61,27.92,13.7S185.93,456.54,183.6,457.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,457.29c-2.33.76-68.82.16-71.34-1.48-1-.6-1.44-10.29-1.68-22v-.37l42.9-.09,0,.73s25.34,11.61,27.92,13.7S185.93,456.54,183.6,457.29Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.87,454.7c-11.2-.37-56.44-.84-67.54-.36-.09,0-.1.07,0,.07,11.09.62,56.33.72,67.54.48C183.11,454.88,183.11,454.71,182.87,454.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.25,433.5c-4.4-.87-9.8-.24-13.2,2.87-.13.12,0,.31.18.27a61.88,61.88,0,0,1,13-2.59A.28.28,0,0,0,158.25,433.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42,435.44c-4.4-.86-9.81-.23-13.2,2.88-.14.12,0,.31.18.26a62.51,62.51,0,0,1,13-2.58A.28.28,0,0,0,161.42,435.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,437.39c-4.41-.86-9.81-.23-13.21,2.88-.13.12,0,.3.19.26a61.65,61.65,0,0,1,13-2.58A.28.28,0,0,0,164.59,437.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.38,198s-.93,19.42-5.37,34.8c-.36,1.27-.75,2.52-1.16,3.72a72.05,72.05,0,0,0-11.7,6s-.46,15.62-.93,33c-.51,19.48-1.05,41.21-.93,45.81.41,17.24-2.13,112-2.13,112l-47.88.2s8.63-105.86,8.57-112.18c-.09-10.15,2.31-55,4.16-87.73,1.14-20.16,2.07-35.7,2.07-35.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.51,424.91c-7.31-.12-5.21-.18-12.52-.22-3.58,0-27.11-.12-30.45.45-.07,0-.07.14,0,.15,3.35.54,26.87.23,30.45.18,7.31-.11,5.21-.16,12.52-.34A.11.11,0,0,0,153.51,424.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1,205c-.87,26.71-1.8,53.43-3,80.12s-2.8,53.58-5,80.3c-1.25,14.93-2.42,35.94-4,50.83,0,.1.14.14.16,0,3.48-26.5,5.41-59.26,7.12-85.93s2.86-53.36,3.77-80.06c.51-15.1.9-30.21,1.35-45.32C126.44,204.72,126.11,204.74,126.1,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,235.37a88.73,88.73,0,0,0-13.69,7.17.16.16,0,0,0,.15.28c4.61-2.25,9.33-4.41,13.82-6.9A.31.31,0,0,0,172.84,235.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.1,218.89c-.31,1.7-.73,3.39-1.09,5.08s-.6,3.21-1,4.77a8.14,8.14,0,0,1-2.22,4c-.63.58-1.31,1.09-2,1.62-.35.28-.74.56-1.11.85,0-.23.09-.46.13-.69l.33-1.93c.24-1.44.47-2.87.69-4.31.43-2.82.82-5.68,1.41-8.47,0-.12-.15-.16-.17,0-.71,2.77-1.48,5.52-2.1,8.31-.3,1.37-1.37,8.13-1.41,8.61s-.09,1-.11,1.49a5.53,5.53,0,0,0,0,1.52c0,.12.18.1.23,0h0a6.56,6.56,0,0,0,.43-1.47c.12-.48.23-1,.31-1.46,0-.18.06-.36.09-.54.66-.41,1.28-.94,1.9-1.39s1.36-1,2-1.5a7.57,7.57,0,0,0,2.43-3.79,27.69,27.69,0,0,0,.8-4.86c.21-1.93.37-3.86.64-5.77C173.29,218.82,173.12,218.78,173.1,218.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,147.23c2.66,7.41,12,24,26.35,37.08,5.55,5.05,46.84,1.73,50.93.14,2.86-1.12,8.2-21.93,5.19-23.81-5.64-3.53-42.55,4.61-44.12,3.78-2.4-1.28-18.3-11.93-28.53-22C163.11,135,156.36,134.92,160.76,147.23Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.38,169.11l23.42-9.3s-21-18.07-28.7-21.64c-8.65-4-8.81,1.28-5.77,9.81S171.38,169.11,171.38,169.11Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.38,169.11l23.42-9.3s-21-18.07-28.7-21.64c-8.65-4-8.81,1.28-5.77,9.81S171.38,169.11,171.38,169.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.85,157c-.86.19-8.2,3-9.79,3.62s-8.08,3.19-9.66,4a.06.06,0,0,0,0,.12c1.7-.49,8.26-3,9.88-3.66s8.84-3.54,9.59-4C190,157,189.91,157,189.85,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.41,165.52l-9,3.59s-8-12.59-11-21.12c-2.22-6.24-2.73-10.76.53-11.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,219.14c.15.17,66.39.6,67-.07.85-1-13.86-72.77-20.63-81.66-1.44-1.9-10.58-4.49-15.88-.17-11.26,9.17-21,40.65-23.3,50.15C120.16,203,116.18,218.52,116.73,219.14Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.47,138h-17.1c.28-.26.56-.5.84-.73a6.55,6.55,0,0,1,.53-.39h14.73a2.91,2.91,0,0,1,.62.56A5.43,5.43,0,0,1,163.47,138Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,141.19H143.42c.31-.39.62-.77.94-1.13h20.22C164.74,140.41,164.9,140.79,165.07,141.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31,144.41H141.1c.26-.39.51-.76.77-1.13h24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,147.62H139.13c.22-.38.44-.76.67-1.13H167C167.16,146.86,167.28,147.24,167.4,147.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.42,150.84h-31c.2-.38.39-.76.6-1.13h30.1C168.18,150.08,168.3,150.46,168.42,150.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.37,154.06H135.76c.18-.38.36-.76.55-1.13H169Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,157.27h-36l.51-1.13H170C170.07,156.51,170.17,156.89,170.28,157.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.15,160.49H132.89l.48-1.13h37.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,163.71H131.59c.14-.38.29-.75.45-1.13h39.67C171.8,163,171.9,163.33,172,163.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.82,166.92H130.35c.14-.38.28-.75.43-1.13h41.76C172.63,166.17,172.73,166.54,172.82,166.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.63,170.14H129.18c.13-.38.27-.75.41-1.13h43.76C173.44,169.39,173.53,169.76,173.63,170.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.41,173.35H128.07c.12-.37.25-.75.39-1.12h45.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,176.57H127l.36-1.13h47.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93,179.79H126c.11-.37.22-.75.34-1.13h49.33C175.76,179,175.85,179.42,175.93,179.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.68,183H125.07l.32-1.12h51C176.5,182.26,176.59,182.63,176.68,183Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,186.22H124.2c.09-.35.19-.73.29-1.13h52.66C177.23,185.47,177.32,185.84,177.4,186.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.12,189.44h-54.7l.27-1.13h54.18C178,188.69,178,189.07,178.12,189.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,192.65H122.64l.27-1.12h55.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,195.87H121.86l.27-1.13h57.13C179.35,195.12,179.43,195.49,179.5,195.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,199.09h-59.1l.27-1.13H180C180,198.34,180.11,198.72,180.18,199.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,202.3H120.3l.27-1.13h60C180.69,201.55,180.77,201.93,180.84,202.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.49,205.52h-62c.1-.37.19-.75.28-1.13h61.47C181.34,204.77,181.42,205.15,181.49,205.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.12,208.74H118.75c.09-.37.17-.74.27-1.13H181.9C182,208,182.05,208.37,182.12,208.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.72,212H118c.08-.37.17-.74.26-1.13h64.25C182.58,211.21,182.65,211.58,182.72,212Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.28,215.17h-66c.07-.35.15-.73.25-1.13h65.55C183.16,214.44,183.22,214.81,183.28,215.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74,218.39h-67c0-.3.09-.68.17-1.13H183.6C183.67,217.72,183.71,218.1,183.74,218.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,147c-2.28.34-9-3.83-11.51-8.33-.17-.31,1-12.76.94-15.25,0-.51,15.66,3.61,15.66,3.61a39.74,39.74,0,0,0-1.39,9.58,5.48,5.48,0,0,0,.12,1c0,.05,0,.1,0,.17C164.38,139.78,163.54,146.54,160.2,147Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64,123.53c.63,3.77,3.16,14.32,11.8,14.42a10,10,0,0,0,1.6-.11l0-.17a6.5,6.5,0,0,1-.11-1,39.74,39.74,0,0,1,1.39-9.58S154.11,124.13,150.64,123.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.15,102.42c-2.8,5.06-3.25,21.32-.13,25.62,4.51,6.24,13.56,8.66,19.28,2.86,5.54-5.63,5.75-26.83,2.12-30.91C167.07,94,155.29,94.93,151.15,102.42Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,115.35s-.08.05-.08.1c0,1.09-.19,2.35-1.19,2.68,0,0,0,.06,0,.06C164.37,118.06,164.6,116.39,164.42,115.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,114.18c-1.75-.19-2,3.33-.38,3.51S165,114.34,163.48,114.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,115.71s.08.05.08.1c-.12,1.09-.06,2.36.9,2.79,0,0,0,.07,0,.06C170.22,118.4,170.17,116.72,170.45,115.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.51,114.64c1.76,0,1.65,3.52,0,3.53S170,114.64,171.51,114.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,113a12.12,12.12,0,0,0,1.4-.38,2.37,2.37,0,0,0,1.35-.66.74.74,0,0,0-.06-.91,1.84,1.84,0,0,0-1.85-.33,2.75,2.75,0,0,0-1.65,1.07A.8.8,0,0,0,162,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,112.18a13,13,0,0,1-1.37-.46,2.42,2.42,0,0,1-1.32-.74.77.77,0,0,1,.11-.91,1.87,1.87,0,0,1,1.87-.22,2.77,2.77,0,0,1,1.58,1.16A.79.79,0,0,1,173,112.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,125.14c.24.28.48.65.87.71a2.91,2.91,0,0,0,1.2-.19,0,0,0,0,1,0,.06,1.46,1.46,0,0,1-1.43.49,1.17,1.17,0,0,1-.79-1C162.28,125.12,162.36,125.1,162.4,125.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.78,122a3.74,3.74,0,0,0,2.37,1.84,4.89,4.89,0,0,0,1.33.15,1.11,1.11,0,0,0,.26,0l.24,0a.28.28,0,0,0,.24-.23h0v-.12h0v-.1c.08-.84.09-2.12.09-2.12.3.17,1.82,1,1.82.55a55.47,55.47,0,0,0-.63-11.36c0-.13-.21-.11-.2,0-.18,3.51.25,7,.13,10.56a6.37,6.37,0,0,0-1.72-.66c-.12,0,0,2.48,0,2.85a.1.1,0,0,1,0,0,5.17,5.17,0,0,1-3.77-1.47C163.81,121.79,163.72,121.86,163.78,122Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,123.48a4.38,4.38,0,0,1-1.86,1.24,1.93,1.93,0,0,1-1.21,0c-.86-.29-.82-1.09-.61-1.76a4.73,4.73,0,0,1,.46-1A5.73,5.73,0,0,0,167,123.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.15,124.72a1.93,1.93,0,0,1-1.21,0c-.86-.29-.82-1.09-.61-1.76A2,2,0,0,1,165.15,124.72Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.24,117.24c3-.39,5.88-9.77,5.88-9.77s-.64,4.07.14,4.08,4.74-5,5.68-9a31.25,31.25,0,0,0,6.73,4.62c3.46,1.63,7.51,2,7.61,1.37.27-1.84-.68-6.88-2.93-9a13.11,13.11,0,0,0-12.66-3.51c-6.26,1.39-8.38,5-9.7,7.78S148.14,117.38,149.24,117.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.44,121.17A4.84,4.84,0,1,1,167,116h0a4.85,4.85,0,0,1-5.59,5.21Zm1.45-8.92a4.57,4.57,0,0,0-1,0,4.2,4.2,0,1,0,1,0Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.54,121.6c-1.83-.3-3.19-2.44-3.08-5a5.81,5.81,0,0,1,1.18-3.34,3,3,0,0,1,5.15.23,5.74,5.74,0,0,1,.87,3.42c-.11,2.67-1.82,4.77-3.81,4.68A1.55,1.55,0,0,1,172.54,121.6Zm1-9-.24,0a2.55,2.55,0,0,0-2.11,1.1,5.15,5.15,0,0,0-1,3c-.1,2.31,1.14,4.24,2.77,4.31s3-1.74,3.14-4a5.08,5.08,0,0,0-.77-3A2.67,2.67,0,0,0,173.49,112.63Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.85,116.52l-.4-.52c.76-.58,2.5-1.33,3.62,0l-.49.42C168.57,115.22,166.92,116.46,166.85,116.52Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2,117l-.56-.32c.15-.26,1.51-2.56,3-2.73s9,.81,9.41.87l-.09.64a82.39,82.39,0,0,0-9.24-.87C147.72,114.73,146.56,116.4,146.2,117Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.8,115.88s-2.58-5.76-5.13-4.93-1.28,8.7,1.23,10.22a2.79,2.79,0,0,0,4-.77Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.09,113.19a0,0,0,0,0,0,.07c1.75,1.13,2.41,3.09,2.77,5a1.55,1.55,0,0,0-2.2-.85.07.07,0,0,0,0,.12,1.71,1.71,0,0,1,1.75.94,8.22,8.22,0,0,1,.61,1.68c.06.19.38.15.35,0v0C150.87,117.68,149.64,113.93,147.09,113.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42,96.26a22.89,22.89,0,0,0-6.06-2.82c-2.41-.67-10.24-1.21-12.32.07s-3.64,8.5-3.85,9.56-.67,7.58,1.43,9.48,3.94-9,8.16-12.12S167.42,96.26,167.42,96.26Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42,96.26s-8.42,1.08-12.64,4.17-6.05,14-8.16,12.12c-.93-.84-1.28-1.93-1.45-3.7,1-3.13,3-7.91,6.15-11,3-2.86,7.52-3.85,12.19-3.7A26.36,26.36,0,0,1,167.42,96.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.31,119.15c.64-2.89,4.75-10.27,8.52-14.3s13.31-5.29,14.58-5c3.08.63,4,1.73,4.53,1.52s-2.33-3-3.12-3.66-3-2.23-4.33-2.4-9.8-.56-13.35,2.55-9.29,12.44-8.88,15.1c.1.64.85,1.15,1,2.06.18,1.19.22,2.54.45,3.38C145.87,119.06,146.25,119.4,146.31,119.15Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,103a15.13,15.13,0,0,1-1.8-1.78,10.52,10.52,0,0,1-1.46-2.1,0,0,0,0,0-.09,0,8.22,8.22,0,0,0,1.27,2.3,7,7,0,0,0,2,1.68A.08.08,0,0,0,155.84,103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,116.23c-.05-.23-.16-.43-.23-.65a3.34,3.34,0,0,1-.17-.76,6.59,6.59,0,0,0-.13-1.47,5.12,5.12,0,0,0-.54-1.07,2,2,0,0,1-.4-1.27c0-.06-.09-.08-.1,0a5,5,0,0,0,.65,2.41A9.21,9.21,0,0,1,146,115a2.29,2.29,0,0,0,.59,1.33A.09.09,0,0,0,146.71,116.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.18,113.22a7.45,7.45,0,0,1-1.15-2.3c-.13-.39-.22-.8-.34-1.2s-.35-.93-.47-1.41a0,0,0,1,0-.09,0c.12.5.16,1,.27,1.52a10.93,10.93,0,0,0,.38,1.27,6.71,6.71,0,0,0,.54,1.15,3.23,3.23,0,0,0,.82,1A0,0,0,0,0,148.18,113.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.66,110.52a8.28,8.28,0,0,1-1.33-2c-.33-.72-.61-1.46-.89-2.2,0-.05-.11,0-.1,0a10.23,10.23,0,0,0,.69,2.37,5.37,5.37,0,0,0,.61,1,5.6,5.6,0,0,0,.94.88S149.7,110.57,149.66,110.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.21,108a3.08,3.08,0,0,1-.66-.9c-.2-.36-.4-.73-.58-1.11s-.37-.71-.54-1.07a2.93,2.93,0,0,1-.37-1.15s-.09-.06-.1,0a3,3,0,0,0,.17,1.19,7.31,7.31,0,0,0,.5,1.24,9.8,9.8,0,0,0,.66,1.13,1.88,1.88,0,0,0,.85.78C151.21,108.1,151.28,108,151.21,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.55,104.61c-.23-.3-.46-.61-.66-.93s-.4-.65-.59-1-.39-.69-.57-1c0-.06-.1,0-.09,0a7.66,7.66,0,0,0,.39,1.14,8.83,8.83,0,0,0,.56,1,9.11,9.11,0,0,0,.68,1,3.27,3.27,0,0,0,.85.81c.06,0,.12,0,.1-.09A5.83,5.83,0,0,0,152.55,104.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.32,101.62a12.73,12.73,0,0,0-.73-1.17,13.88,13.88,0,0,0-.9-1.1,13.29,13.29,0,0,0-2-1.86c-.05,0-.12,0-.08.07,1.21,1.38,2.48,2.72,3.67,4.11A0,0,0,0,0,158.32,101.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.45,99.38a5.61,5.61,0,0,0-.85-1.09,12.74,12.74,0,0,0-2.3-1.76c-.05,0-.11,0-.06.08.68.61,1.38,1.22,2,1.87a12.57,12.57,0,0,1,.91,1c.29.35.49.76.75,1.13,0,0,.07,0,.07,0A3.4,3.4,0,0,0,160.45,99.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.05,98.59a6.32,6.32,0,0,0-.77-1.07A7.57,7.57,0,0,0,160.33,96c-.05,0-.1,0-.06.08a13.61,13.61,0,0,1,1.8,1.76c.28.32.53.65.8,1s.46.72.75,1a0,0,0,0,0,0,0A6.82,6.82,0,0,0,163.05,98.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,97.39c-.27-.29-.55-.57-.84-.85a3.86,3.86,0,0,0-.93-.72c-.05,0-.09,0-.05.08.53.57,1,1.14,1.56,1.71a11,11,0,0,1,1.13,1.81,0,0,0,0,0,.06,0A3.81,3.81,0,0,0,165,97.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,97.24a6.09,6.09,0,0,0-1.77-1.5s-.1.05,0,.08a7.73,7.73,0,0,1,1.58,1.6,10.1,10.1,0,0,1,1.14,1.93s.07,0,.07,0A5,5,0,0,0,167.28,97.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,99a4.68,4.68,0,0,0-.18-.48,5.7,5.7,0,0,0-.54-.89,11.11,11.11,0,0,0-1.47-1.52s-.11,0-.06.08a8.34,8.34,0,0,1,1.36,1.54,6.71,6.71,0,0,1,.51.86c.07.15.14.3.2.45a3,3,0,0,0,.18.45,0,0,0,0,0,.09,0A1.51,1.51,0,0,0,170,99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.69,99.38a7.74,7.74,0,0,0-.43-.73,7.1,7.1,0,0,0-.53-.67c-.19-.22-.39-.43-.58-.66,0,0-.12,0-.07.07a5.15,5.15,0,0,1,.53.7l.46.69.45.69c.16.24.28.5.46.72a0,0,0,0,0,.07,0A3.85,3.85,0,0,0,171.69,99.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,144.73c-8.88,15-24.47,52.12-18.46,60,8.08,10.53,34,23.6,42.36,24.88,3.61.56,12.53-26.73,9-28.34-4.26-1.93-27.93-12.51-28-13.93s3.23-18.66,4-33.41C150.47,136.76,145.66,136.51,140.78,144.73Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,201.48s11-1.83,18.17-2.69c4-.48,11-.69,14.13.31,4.67,1.49,23.24,10.73,21.09,15.28-1.94,4.12-16.88-5.84-16.88-5.84s16,8.71,12.72,13.24-18.63-9-18.63-9,16.2,9.33,12.12,13.47c-3.09,3.13-17.72-8.31-17.72-8.31s13.87,8.11,10.84,11.47c-3.36,3.71-17.52-6-17.52-6-9.16,7.23-16.48,6.93-21.66,6.09C163.17,229.32,167.76,201.48,167.76,201.48Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.94,205.17c1.91,1,3.86,1.91,5.68,3s3.6,2.31,5.31,3.6a36.74,36.74,0,0,1,6.17,5.64c-3.53-3.51-10-7.63-11.81-8.75s-3.58-2.33-5.39-3.46C198.85,205.21,198.89,205.14,198.94,205.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.77,211.67c2.39,1.33,4.81,2.56,7.14,4s4.4,3,6.61,4.56c.17.12,0,.17-.13.06-2.27-1.49-4.49-2.7-6.79-4.16s-4.53-3-6.87-4.4C194.69,211.7,194.73,211.65,194.77,211.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.18,216.61a61.2,61.2,0,0,1,10.46,6.93c.16.13,0,.18-.18.06-3.43-2.37-6.11-4.26-10.34-6.86C190.05,216.7,190.1,216.57,190.18,216.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,171.93l-25.2,0s12.82-24.58,18.63-30.74c6.53-6.94,8.65-2.08,9,7S148.45,171.93,148.45,171.93Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,171.93l-25.2,0s12.82-24.58,18.63-30.74c6.53-6.94,8.65-2.08,9,7S148.45,171.93,148.45,171.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.82,167.66c-.88-.13-8.73-.18-10.44-.15s-8.69.06-10.45.24a.06.06,0,0,0,0,.12c1.76.16,8.8.14,10.54.15s9.51-.11,10.37-.25C147.9,167.76,147.88,167.67,147.82,167.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.16,161c1,4.26,4.47,10.08,4.14,13.3a3.71,3.71,0,0,1-2.88,3.38s2.78,2.27,2,5.15c-.4,1.48-3.13,2.14-3.13,2.14s2.15,1.92,1.3,4.43c-.69,2-3.31,2.36-3.31,2.36s1.2,2.8-.15,4.62c-2.74,3.69-20.47-.32-21.73-7.47-.59-3.33,3.69-2.12,3.69-2.12s-5.73-3.23-5-6.91,6.19-1.76,6.19-1.76-5.52-3.18-4.38-6.92,6.33-1,6.33-1-3.34-3.56-1.8-6.22c2.53-4.39,10.13,3.55,14.24,3.51l1.76-6.25Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.08,167.32c-.56-4.12,2.55-5.13,3.13-9.09.65-4.41-4.73-4.44-7.72,2.78l-1.82,6.47Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.86,191.91a.05.05,0,0,1,0,.1,31.55,31.55,0,0,1-18-5.23c-.17-.11-.05-.44.16-.34A64.62,64.62,0,0,0,246.86,191.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,185.05c.07,0,.06.13,0,.13-6.34.07-13.94-2.14-19.3-6.92-.19-.16-.19-.49,0-.32C233.89,180.85,243.54,184.25,249.36,185.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,169.72c5.32,4.39,11.52,6.62,18.21,8,.08,0,.05.14,0,.14-3.46.22-7.63-1.11-10.79-2.42a18.23,18.23,0,0,1-7.54-5.54C231.72,169.81,231.84,169.63,232,169.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.77,138.08l45-.78A16.46,16.46,0,0,1,281,142.52c6.72,7.14,12.81,18.87,18.61,35.86l-45,.78c-5.8-17-11.89-28.71-18.61-35.85A16.47,16.47,0,0,0,223.77,138.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,172c5.28-.2,10.57-.27,15.85-.4s10.56-.17,15.84-.16c-5.28.2-10.56.27-15.84.41S262.21,172,256.92,172Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,172.28c-.24-.62-.49-1.26-.72-1.92l0-.12h.12l2.17-.12h.1l0,.09.61,2,0,.13h-.13C292.37,172.32,291.64,172.3,291,172.28Zm0,0c.75-.06,1.46-.12,2.17-.15l-.1.12-.65-2,.12.08c-.72,0-1.44,0-2.17.06l.09-.12C290.6,170.93,290.76,171.59,291,172.28Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,171.49a8.63,8.63,0,0,1-.73-.6l.16,0a8.44,8.44,0,0,1-.91,1.95,9.11,9.11,0,0,1,.73-2l.07-.14.09.11C291.84,171,292,171.23,292.22,171.49Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28,167.55c5.28-.2,10.57-.26,15.85-.4S281.69,167,287,167c-5.28.2-10.56.27-15.84.4S260.57,167.57,255.28,167.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,167.87c-.24-.61-.49-1.25-.72-1.92l0-.11h.12l2.17-.12h.1l0,.1.61,2,0,.13h-.13C290.74,167.92,290,167.9,289.31,167.87Zm0,0,2.17-.15-.1.13-.65-2,.12.09c-.72,0-1.44,0-2.17.06l.09-.12C289,166.53,289.12,167.19,289.31,167.87Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.58,167.08a7,7,0,0,1-.73-.59l.16,0a8.64,8.64,0,0,1-.91,1.95,8.94,8.94,0,0,1,.73-2l.07-.14.09.11C290.2,166.58,290.39,166.83,290.58,167.08Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,163.15c5.28-.2,10.57-.26,15.85-.4s10.56-.17,15.84-.15c-5.28.2-10.56.26-15.84.4S258.93,163.17,253.64,163.15Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.67,163.47c-.24-.61-.49-1.26-.72-1.92l0-.11H287c.73-.06,1.45-.08,2.17-.12h.1l0,.09.61,2,0,.13h-.13C289.09,163.52,288.36,163.49,287.67,163.47Zm0,0c.75-.06,1.46-.12,2.17-.15l-.1.13-.65-2,.12.09c-.72,0-1.44.05-2.17.05l.09-.12C287.32,162.13,287.48,162.78,287.67,163.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,162.68a8.63,8.63,0,0,1-.73-.6l.16,0a8.71,8.71,0,0,1-.91,2,8.94,8.94,0,0,1,.73-2l.07-.14.09.11C288.56,162.18,288.75,162.43,288.94,162.68Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.58,158.75c5.28-.2,10.56-.27,15.84-.4s10.57-.17,15.85-.16c-5.28.2-10.56.27-15.84.41S256.87,158.76,251.58,158.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61,159.07c-.24-.62-.49-1.26-.72-1.92l0-.12H285c.72-.05,1.45-.08,2.17-.12h.09l0,.09.61,2,0,.12h-.13C287,159.11,286.3,159.09,285.61,159.07Zm0,0c.75-.06,1.46-.12,2.16-.15l-.09.12-.66-2,.13.08c-.72,0-1.45.06-2.17.06l.08-.12C285.25,157.72,285.42,158.38,285.61,159.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.88,158.28a8.63,8.63,0,0,1-.73-.6l.16,0a9.36,9.36,0,0,1-.91,1.95,9.11,9.11,0,0,1,.73-2l.07-.14.09.11C286.5,157.78,286.69,158,286.88,158.28Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.28,154.34c5.28-.2,10.56-.26,15.84-.4s10.56-.16,15.85-.15c-5.28.2-10.57.27-15.85.4S254.56,154.36,249.28,154.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,154.66c-.23-.61-.49-1.25-.72-1.92l0-.11h.13c.72-.05,1.44-.08,2.16-.12h.1l0,.1.6,2,0,.13h-.13C284.73,154.71,284,154.69,283.3,154.66Zm0,0,2.17-.15-.09.13-.66-2,.12.09c-.72,0-1.44.05-2.17.06l.09-.12C283,153.32,283.12,154,283.3,154.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.57,153.88q-.37-.28-.72-.6l.16,0a8.91,8.91,0,0,1-.92,1.95,8.94,8.94,0,0,1,.73-2l.07-.14.1.11A8.61,8.61,0,0,1,284.57,153.88Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.31,149.71c5.28-.2,10.56-.26,15.85-.4s10.56-.17,15.84-.15c-5.28.2-10.56.26-15.84.4S251.6,149.73,246.31,149.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.34,150c-.24-.61-.49-1.26-.72-1.92l0-.11h.12c.72-.06,1.45-.08,2.17-.12h.1l0,.09.61,2,0,.13h-.13C281.76,150.08,281,150.05,280.34,150Zm0,0c.75-.06,1.46-.12,2.16-.15l-.09.13-.65-2,.12.08c-.72,0-1.45.06-2.17.06l.09-.12C280,148.69,280.15,149.34,280.34,150Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.61,149.24a8.63,8.63,0,0,1-.73-.6l.16,0a8.44,8.44,0,0,1-.91,1.95,8.86,8.86,0,0,1,.73-2l.07-.14.09.11A8.54,8.54,0,0,1,281.61,149.24Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.81,145.08c5.28-.2,10.56-.27,15.84-.41s10.57-.16,15.85-.15c-5.28.2-10.56.27-15.84.4S248.09,145.09,242.81,145.08Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.84,145.39c-.24-.61-.49-1.25-.72-1.91l0-.12h.12c.72,0,1.45-.08,2.17-.12h.09l0,.09.61,2,0,.13H279C278.26,145.44,277.53,145.42,276.84,145.39Zm0,0c.75,0,1.46-.11,2.16-.14l-.09.12-.66-2,.13.09-2.17.06.08-.12C276.48,144.05,276.65,144.71,276.84,145.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.1,144.61q-.37-.29-.72-.6l.16,0a9.36,9.36,0,0,1-.91,2,9.11,9.11,0,0,1,.73-2l.07-.14.09.11A8.2,8.2,0,0,1,278.1,144.61Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.38,140.44c5.28-.2,10.56-.26,15.84-.4s10.57-.17,15.85-.15c-5.28.2-10.56.26-15.84.4S242.66,140.46,237.38,140.44Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.41,140.76c-.24-.61-.49-1.25-.72-1.92l0-.11h.12c.72-.05,1.45-.08,2.17-.12H273l0,.09.61,2,0,.13h-.13C272.83,140.81,272.1,140.78,271.41,140.76Zm0,0c.75-.06,1.46-.12,2.16-.15l-.09.13-.66-2,.13.09-2.17.06.08-.13C271.05,139.42,271.22,140.07,271.41,140.76Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.67,140q-.37-.28-.72-.6l.16,0a9.68,9.68,0,0,1-.91,2,8.94,8.94,0,0,1,.73-2l.07-.14.09.11A8.07,8.07,0,0,1,272.67,140Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,138.08l45-.78c-5.91.1-11.78,3.69-15.6,9-9.76,13.57-18.11,55.72-18.51,81.58-.14,8.83,3.41,24.13,7.18,40.33,5,21.34,10.57,45.52,9.52,61.92-.79,12.35-4.46,27.17-8.34,42.85-3.37,13.57-6.84,27.61-8.81,41.35-2.33,16.32-.34,35.63,4.08,39.71a12.43,12.43,0,0,0,8.87,3.6l-45,.79a12.44,12.44,0,0,1-8.86-3.6c-4.43-4.08-6.42-23.39-4.09-39.72,2-13.73,5.45-27.77,8.81-41.34,3.88-15.69,7.55-30.5,8.35-42.85,1-16.4-4.57-40.59-9.53-61.93-3.77-16.19-7.32-31.5-7.18-40.32.4-25.86,8.75-68,18.51-81.59C212.45,141.77,218.32,138.19,224.23,138.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.48,404.31l45-.78c-9.67.17-21,12.83-33,26.24-12.24,13.66-24.8,27.69-35.83,27.88l-45,.79c11-.2,23.59-14.22,35.83-27.89C250.47,417.15,261.81,404.48,271.48,404.31Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.3,456c5.28-.2,10.56-.27,15.84-.41s10.56-.17,15.84-.15c-5.28.2-10.56.26-15.84.4S220.58,456,215.3,456Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.32,456.34c.26-.63.51-1.31.8-2l0-.05h.06c.78,0,1.56,0,2.34,0h.2l-.09.18-.94,2,0,.06h-.07Zm0,0,2.32,0-.09.06.89-2,.11.18c-.78,0-1.56,0-2.34,0l.09-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.4,455.47a4.37,4.37,0,0,1-.32-.55l.16,0a14.54,14.54,0,0,1-1.92,1.84,14,14,0,0,1,1.78-2l.12-.11,0,.15A4,4,0,0,1,250.4,455.47Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.2,452.31c5.28-.2,10.56-.27,15.84-.41s10.56-.17,15.85-.15c-5.28.2-10.56.26-15.84.4S225.48,452.32,220.2,452.31Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,452.62c.25-.63.5-1.31.8-2l0-.05h.06c.78,0,1.56,0,2.34,0h.2l-.08.18-.94,2,0,.06h-.06Zm0,0,2.31,0-.09.06.89-2,.11.18c-.78,0-1.56,0-2.34,0l.09-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3,451.75a6.05,6.05,0,0,1-.32-.55l.17,0a14.54,14.54,0,0,1-1.92,1.84,13.91,13.91,0,0,1,1.77-2l.12-.11,0,.15A4,4,0,0,1,255.3,451.75Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,448.59c5.28-.2,10.56-.27,15.84-.41s10.57-.17,15.85-.15c-5.28.2-10.56.26-15.84.4S230.39,448.6,225.1,448.59Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.13,448.9c.26-.63.5-1.31.8-2l0-.05H259c.78,0,1.56,0,2.34,0h.2l-.09.18-.94,2,0,.06h-.06Zm0,0,2.31,0-.09.06.89-2,.12.18c-.78,0-1.56,0-2.34,0l.08-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,444.87c5.27-.2,10.56-.27,15.84-.41s10.56-.17,15.84-.15c-5.28.2-10.56.26-15.84.4S234.75,444.88,229.47,444.87Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.49,445.18c.26-.63.51-1.31.8-2l0-.05h.06c.78,0,1.56,0,2.34,0h.2l-.09.18-.94,2,0,.06h-.07Zm0,0,2.32,0-.09.06.89-2,.11.18c-.78,0-1.56,0-2.34,0l.08-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.45,441.15c5.28-.2,10.57-.27,15.85-.41s10.56-.17,15.84-.16c-5.28.21-10.56.27-15.84.41S238.74,441.16,233.45,441.15Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.48,441.46c.26-.63.51-1.31.8-2l0-.05h.07c.78,0,1.56,0,2.34,0h.2l-.09.18-.94,2,0,.06h-.06Zm0,0,2.32,0-.09.06.89-2,.11.18c-.78,0-1.56,0-2.34,0l.08-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.71,437.43c5.28-.2,10.56-.27,15.84-.41s10.57-.17,15.85-.16c-5.28.21-10.56.27-15.84.41S242,437.44,236.71,437.43Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,437.74c.26-.63.5-1.31.8-2l0-.05h.07c.78,0,1.56,0,2.34,0h.2l-.09.17-.94,2,0,.06h-.06Zm0,0,2.31,0-.09.06.89-2,.12.18c-.78,0-1.56,0-2.34,0l.08-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.38,433.71c5.28-.2,10.56-.27,15.84-.41s10.57-.17,15.85-.16c-5.28.21-10.56.27-15.84.41S245.67,433.72,240.38,433.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.41,434c.26-.63.5-1.31.8-2l0,0h.07c.78,0,1.56,0,2.34,0h.2l-.09.17-.94,2,0,.06h-.06Zm0,0,2.31,0-.09.06.89-2,.12.18c-.78,0-1.56,0-2.34,0l.08-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,430c5.28-.2,10.56-.27,15.84-.41s10.57-.17,15.85-.16c-5.28.21-10.56.27-15.84.41S249.08,430,243.8,430Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.83,430.3c.25-.63.5-1.31.8-2l0-.05h.06c.78,0,1.57,0,2.35,0h.19l-.08.17-.94,2,0,.06h-.06Zm0,0,2.31,0-.09.06.89-2,.12.18c-.79,0-1.57,0-2.35,0l.09-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,426.27c5.27-.2,10.56-.27,15.84-.41s10.56-.17,15.84-.16c-5.28.21-10.56.27-15.84.41S252.27,426.28,247,426.27Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,426.58c.26-.63.51-1.31.8-2l0,0h.06c.78,0,1.56,0,2.34,0h.2l-.09.17-.94,2,0,.06h-.07Zm0,0,2.32,0-.09,0,.89-2,.11.18c-.78,0-1.56,0-2.34,0l.08-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.51,422.55c5.28-.2,10.56-.27,15.84-.41s10.56-.17,15.85-.16c-5.28.21-10.57.27-15.85.41S255.79,422.56,250.51,422.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.53,422.86c.26-.63.51-1.31.8-2l0-.06h.06c.78,0,1.56,0,2.34,0h.2l-.08.17-.94,2,0,.06h-.07Zm0,0,2.32,0-.09.05.89-2,.11.18c-.78,0-1.56,0-2.34,0l.09-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.42,418.83c5.28-.2,10.56-.27,15.84-.41s10.57-.17,15.85-.16c-5.28.21-10.56.27-15.84.41S258.71,418.84,253.42,418.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.45,419.13c.26-.62.5-1.3.8-2l0-.06h.07c.78,0,1.56,0,2.34,0h.2l-.09.17-.94,2,0,.06h-.06Zm0,0,2.31,0-.09,0,.89-2,.12.18c-.78,0-1.56,0-2.34,0l.08,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,415.11c5.28-.2,10.57-.27,15.85-.41s10.56-.17,15.84-.16c-5.28.21-10.56.27-15.84.41S262.31,415.12,257,415.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.05,415.41c.26-.62.51-1.3.8-2l0-.06h.06c.78,0,1.56,0,2.34,0h.2l-.09.17-.94,2,0,.06h-.06Zm0,0,2.32,0-.09.05.89-2,.11.18c-.78,0-1.56,0-2.34,0l.08-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.36,411.39c5.28-.2,10.56-.27,15.84-.41s10.56-.17,15.85-.16c-5.28.21-10.57.27-15.85.41S266.64,411.4,261.36,411.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.38,411.69c.26-.62.51-1.3.8-2l0-.06h.06c.78,0,1.56,0,2.34,0h.2l-.08.17-.94,2,0,.06h-.07Zm0,0,2.32,0-.09,0,.89-2,.11.18c-.78,0-1.56,0-2.34,0l.09,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.41,407.67c5.28-.2,10.56-.27,15.84-.41s10.56-.17,15.84-.16c-5.27.21-10.56.27-15.84.41S270.69,407.68,265.41,407.67Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.43,408c.26-.62.51-1.3.8-2l0-.06h.06c.78,0,1.56,0,2.34,0h.2l-.08.18-.94,2,0,.06h-.07Zm0,0,2.32,0-.09.05.89-2,.11.18c-.78,0-1.56,0-2.34,0l.09-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46,404.33l45-.78c12.81-.23,20.8,14.29,28.53,28.32,6.78,12.31,13.19,23.95,22.16,23.79l-45,.79c-9,.15-15.38-11.48-22.16-23.79C292.26,418.62,284.27,404.11,271.46,404.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1,445.68l45-.79c-9.79.17-15.72,3-21.45,5.77-5.21,2.51-10.14,4.87-17.48,5l-45,.79c7.35-.13,12.27-2.49,17.48-5C345.38,448.7,351.31,445.85,361.1,445.68Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,454.41c4.61-.2,9.23-.27,13.84-.41s9.23-.17,13.85-.15c-4.61.2-9.23.26-13.84.4S342.61,454.42,338,454.41Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,454.72c.25-.63.5-1.31.8-2l0-.05h.06c.78,0,1.56,0,2.34,0h.2l-.08.18-.94,2,0,.06h-.06Zm0,0,2.31,0-.09.06.89-2,.11.18c-.78,0-1.56,0-2.34,0l.09-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.32,451.39c4.78-.2,9.56-.26,14.34-.4s9.56-.17,14.35-.16c-4.78.2-9.57.27-14.35.41S350.1,451.41,345.32,451.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,451.7c.26-.62.51-1.3.8-2l0-.06h.06c.78,0,1.56,0,2.34,0h.2l-.08.18-.94,2,0,.07h-.07Zm0,0,2.32,0-.09.05.89-2,.11.17-2.34,0,.09-.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45,448.59c4.78-.2,9.56-.27,14.34-.41s9.56-.17,14.35-.15c-4.78.2-9.56.26-14.34.4S358.23,448.6,353.45,448.59Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.48,448.9c.25-.63.5-1.31.8-2l0-.05h.06c.78,0,1.56,0,2.34,0h.2l-.08.18-.94,2,0,.06h-.06Zm0,0,2.31,0-.09.06.89-2,.11.18c-.78,0-1.56,0-2.34,0l.09-.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.09,445.68l45-.79c4.74-.08,28.85,10.69,29.87,11.15l-45,.78C389.94,456.36,365.84,445.6,361.09,445.68Z",
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadinglistCuate);
export default __webpack_public_path__ + "static/media/Reading list-cuate.9ee17b7e8fbe7eabb7d097a25b30f444.svg";
export { ForwardRef as ReactComponent };